.container {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.callout {
    padding: 16px;
    min-height: 100px;
}

.list {
    display: flex;
    justify-content: center;
    align-items: center;
}

.item {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 12px;
}
